import { css, keyframes } from '@emotion/react';

const stopButtonStyles = {
    powerStopButton: css({
        borderRadius: '8px',
        backgroundColor: '#000000',
        color: '#ffffff',
        border: 'none',
        fontWeight: '600',
        fontSize: '15px',
        padding: '16px',
        boxShadow: 'none',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',

        ['&:disabled']: {
            backgroundColor: '#D1D5DB',
            color: '#ffffff',
        },
    }),
    stoping: {
        display: 'inline-block',
        position: 'relative',
        width: 20,
        height: 20,
        ['& div']: {
            boxSizing: 'border-box',
            display: 'block',
            position: 'absolute',
            width: 20,
            height: 20,
            border: '3px solid #0057b7',
            borderRadius: '50%',
            animation: '${ldsRingAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
            borderColor: '#0057b7 transparent transparent transparent',

            ['&:nth-of-type(1)']: {
                animationDelay: '-0.45s',
            },
            ['&:nth-of-type(2)']: {
                animationDelay: '-0.3s',
            },
            ['&:nth-of-type(3)']: {
                animationDelay: '-0.15s',
            },

            '@keyframe spinnerButton': {
                ['0%']: {
                    transform: 'rotate(0deg)',
                },
                ['100%']: {
                    transform: 'rotate(360deg)',
                },
            },
        },
    },
};

const spinnerButton = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const stoppingSpinnerStyles = css`
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    margin-left: 10px;

    & div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        /* margin: 3px; */
        border: 1px solid #ffffff;
        border-radius: 50%;
        animation: ${spinnerButton} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #ffffff transparent transparent transparent;

        &:nth-of-type(1) {
            animation-delay: -0.45s;
        }
        &:nth-of-type(2) {
            animation-delay: -0.3s;
        }
        &:nth-of-type(3) {
            animation-delay: -0.15s;
        }
    }
`;

export default stopButtonStyles;
